import ShippingProgress from './shippingProgress';
import packageStyles from './packageStatus.module.css';
import CollapsibleProductLineList from './collapsibleProductLineList';
import {useI18nContext} from '../../i18n/i18n-react';
import {
    Card,
    CardContent,
    CardHeader,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import {Order} from '../../models/order';

const NoShipments = ({order}: {order: Order}) => {
    const {LL} = useI18nContext();

    if (!order) {
        return <></>;
    }

    const {isCanceled, isRefunded} = order;

    return (
        <Card>
            <CardHeader>
                <Typography
                    variant="h6"
                    component={'span'}
                    lineHeight={'tight'}
                    noMargin
                >
                    Bestelling #{order.orderNumber}
                </Typography>
            </CardHeader>
            <CardContent>
                <div className={packageStyles['info-wrapper']}>
                    <p className={packageStyles.description}>
                        {isCanceled && LL.order.state.canceled.description()}
                        {isRefunded && LL.order.state.refunded.description()}
                        {!isCanceled &&
                            !isRefunded &&
                            LL.order.state.processing.description()}
                    </p>
                </div>
                {!isCanceled && !isRefunded && (
                    <ShippingProgress hasPackages={false} />
                )}
            </CardContent>
            <CollapsibleProductLineList
                products={Object.values(order.items).map((item, index) => ({
                    key: index.toString(),
                    name: item.description,
                    qty: item.qty,
                }))}
            />
        </Card>
    );
};

export default NoShipments;
